import { withDevToolsStub } from "@angular-architects/ngrx-toolkit";
import { patchState, WritableStateSource } from "@ngrx/signals";

// In production, we export the stub that does nothing.
export const withStoreDevtools = (name: string) => withDevToolsStub(name);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function updateState<T extends object>(
  store: WritableStateSource<T>,
  actionName: string,
  state: Partial<T>
): void {
  patchState(store, state);
}
